import { render, staticRenderFns } from "./FormAggregateEnderecos.vue?vue&type=template&id=0a72f302"
import script from "./FormAggregateEnderecos.vue?vue&type=script&lang=js"
export * from "./FormAggregateEnderecos.vue?vue&type=script&lang=js"
import style0 from "./FormAggregateEnderecos.vue?vue&type=style&index=0&id=0a72f302&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports